<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file PostCode.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  PostCode.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div class="md-form mb-0"
    >
        <p>
            <small v-if="explain!==null">{{explain}}</small>
        </p>
        <div class="d-flex justify-content-between align-items-center">
            <transition name="fade">
                <template v-if="address === null">
                    <BaseInputWithIcon
                            class="mb-0"
                            cls="text-uppercase mb-0"
                            icon="location_on"
                            :field="name"
                            label="Postcode"
                            id="postcode"
                            :maxlength="maxLength"
                            :valid_types="null"
                            :invalid="invalid"
                            :error="invalid"
                            :value="postcode"
                            :data_validation_msg="{
                                error:'Incorrect postcode format'
                            }"
                            @keyup="setPostcode"
                    ></BaseInputWithIcon>

                </template>
                <template v-else>
                    <small>{{address}}</small>
                </template>
            </transition>

            <!--            @input_value="setPostcode"-->
            <div v-if="address === null"
                 v-on:click="getPostcode"
                 class="btn btn-sm btn-secondary m-0">
                <i class="material-icons">
                    <template>search</template>
                </i>
            </div>
            <div v-else
                 v-on:click="setPostCodeInvalid"
                 class="btn btn-sm btn-success m-0">
                <i class="material-icons">
                    <template>clear</template>
                </i>
            </div>
        </div>
        <small v-if="post_code_not_found"
               class="invalid-feedback d-block">Post code not found</small>
        <input v-if="address !== null"
               type="hidden"
               name="address"
               :value="address">
        <input v-if="address !== null"
               type="hidden"
               name="postcode"
               :value="readPostcode">

    </div>
</template>

<script>
    import {_} from 'underscore';

    window.Vue.component('BaseInputWithIcon', require('./base/BaseInputWithIcon'));
    export default {
        name: "PostCode",
        props: {
            maps_region: {
                type: String,
                default: null
            },
            maps_api_key: {
                type: String,
                default: null
            },
            name: {
                type: String,
                default: "postcode"
            },
            explain: {
                type: String,
                default: null
            },
        },
        data() {
            return {
                invalid:null,
                url: 'https://maps.googleapis.com/maps/api/geocode/json',
                response: {},
                address: null,
                maxLength: 8,
                postcode: null,
                post_code_not_found:false,
            }
        },
        methods: {
            processResults() {
                let self = this;
                let resultsLen = self.response.results.length;
                if (resultsLen <= 0) {
                    self.address = null;
                    self.$emit('postcode_valid', false);
                    self.post_code_not_found = true;
                } else {
                    /**
                     * @param {String} testAddress.formatted_address
                     * @param {Object} testAddress
                     */
                    let testAddress = _.first(self.response.results);

                    if (typeof testAddress !== 'undefined') {
                        self.address = testAddress.formatted_address;
                        self.$emit('postcode_valid', true);
                        self.post_code_not_found = false;
                    } else {
                        self.setPostCodeInvalid();
                        self.post_code_not_found = true;
                    }
                }
            },
            setPostCodeInvalid() {
                let self = this;

                self.address = null;
                self.postcode = null;
                self.$emit('postcode_valid', false);
            },
            validatePostcode(postcode) {
                // postcode = postcode.replace(/\s/g, "");
let firstChars = /^([Gg][Ii][Rr] 0[Aa]{2})|([A-Za-z][0-9]{1,2})|([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|([AZa-z][0-9][A-Za-z])/i
let pattern = /^(([A-Z][A-HJ-Y]?\d[A-Z\d]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?\d[A-Z]{2}|BFPO ?\d{1,4}|(KY\d|MSR|VG|AI)[ -]?\d{4}|[A-Z]{2} ?\d{2}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$/i;

                return firstChars.test(postcode);
                // console.log(str)
            },
            setPostcode(postcode) {
                let self = this,
                    testPostCode = postcode;

                // console.log('postcode','...'+postcode+'...');

                if (testPostCode === null || testPostCode === '') {
                    return;
                }
                // if (testPostCode.trim() === '') {
                //     self.setPostCodeInvalid();
                //     return;
                // }
                let testValidity = self.validatePostcode(testPostCode);

                self.invalid = !testValidity;

                // console.log(testValidity,testPostCode);
                self.postcode = testPostCode;
            },
            getPostcode() {
                let self = this;

                if (self.postcode === null) {
                    self.post_code_not_found = true;
                    return;
                }
                if (self.postcode.trim() === '') {
                    self.address = null;
                    self.$emit('postcode_valid', false);
                    self.post_code_not_found = true;
                    return;
                }

                // postcode = self.validatePostcode(postcode);

                let axios_data = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    params: {
                        address: self.postcode + ' ' + this.maps_region,
                        sensor: false,
                        key: this.maps_api_key
                    }
                };
                $.getJSON(self.url + '?address='
                    + self.postcode + ' '
                    + this.maps_region
                    + '&sensor=false'
                    + '&key=' + axios_data.params.key,
                    function (response) {
                        //Insert
                        // $('#text').text(number + ', ' + data.results[0].formatted_address);
                        self.processResults(self.response = response);

                        // let result = data.results[0].formatted_address;


                    });
            }
        },
        computed:{
            readPostcode(){
                return this.postcode.trim().substring(0,3);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/PostCode.vue